import * as React from 'react';
import { useChatMessages } from '@/hooks';
import { ChatMessagesProps } from '@/interfaces';
import { BaseChatMessageList } from './BaseChatMessageList';

interface ChatMessageListProps {
	containerRef?: any;
	className?: string;
	messages: ChatMessagesProps[];
	streamingMessageId?: string | null;
	currentBotMessage?: string;
	isLoading?: boolean;
	applicationId?: number;
	conversationId?: string;
	hideHeaderDate?: boolean;
}

export const ChatMessageList: React.FC<ChatMessageListProps> = (props) => {
	const { addChatMessages, date, threadId, isChatAI, user } = useChatMessages();

	return (
		<BaseChatMessageList
			{...props}
			addChatMessages={addChatMessages}
			date={date}
			threadId={threadId}
			user={user}
			showAvatarAndName={!!isChatAI}
			showTimestampCondition={() => !!isChatAI}
			streamingLoaderBgClass="bg-green-20"
		/>
	);
};
